(function($) {  
  var component2    = $("#header");
  var state         = "BEFORE_SCROLL";
  var component     = $("#main");
  var page          = $("#page");
  var body          = $("body");
  burger            = $('.header__nav-button');
  var blurZone      = $("<div class='nav-blur-zone'></div>");
  var isOpen        = false;
  var activeElement = null;





function openBurger(){
  $('.header__nav-button').addClass('header__nav-button_open');
}

// closeBurger

function closeBurger(){
  $('.header__nav-button').removeClass('header__nav-button_open');
}


function open(){
  if(isOpen == false)
  {
    isOpen = true;

    body.css("overflow", "hidden");
    openBurger();
    component.addClass("nav_open");
    blurZone.prependTo("#page");
  }
}

// close
function close(){
  if(isOpen == true)
  {
    isOpen = false;   
    body.css("overflow", "auto");
    closeBurger();
    component.removeClass("nav_open");
    blurZone.remove();
  }
}

// changeState

function changeState(){
  component2.css('transitionDuration', '0.4s');

  if(pageYOffset >= 30 && state === "BEFORE_SCROLL")
  {
    state = "AFTER_SCROLL";
    // console.log(pageYOffset);
    // console.log("scrolling", state);
    component2.addClass("is_sticky");
  }

  else if(pageYOffset < 30 && state === "AFTER_SCROLL")
  {
    state = "BEFORE_SCROLL";
    // console.log(pageYOffset);
    // console.log("not scrolling", state);
    component2.removeClass("is_sticky");
    
  }
}
  
  // Scroll
$(window).on('scroll', function(){
	changeState();
});
$(document).ready(function(){
	changeState();

	
});
  
$('body').on('click', '.nav-blur-zone', function(){
  close();
});


$('body').on('click', '.header__nav-button', function(e){
  if($(this).hasClass('header__nav-button_open')){
    close();
 }
 else {
  open();
  }

});

  


var mode  = $(window).innerWidth() >= 992 ? "PC" : "MOBILE";
  
  if(mode=="PC"){
    

    $('#main li.dropdown').hover(function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
        }, function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
      });

    

  }
  else if(mode=="MOBILE") {
      $('#main li.dropdown').off('hover');
      $('#main li.dropdown > a').removeClass('dropdown-toggle');
      $('#main li.dropdown > a').attr('data-toggle', '');
      $('#main li.dropdown').on('touchend', function() {
          $(this).find('.dropdown-menu').slideToggle(300)
      });
  }


  var mode  = $(window).innerWidth() >= 767 ? "PCS" : "MOBILES";

if(mode=="PCS"){
  
    

  }
  else if(mode=="MOBILES") {
      $('.footer_link_wrap h5').click(function(){
   $(this).next('.footer_link').slideToggle();
  });
  }

  






  $(document).ready(function() {

  $('.featured_img>a').each(function(e) {
     var bg_ = 'url(' + $(this).find('img').attr('src') + ')';
     $(this).find('img').hide();
     $(this).css('background-image', bg_);
    });

  $('.home-slider').slick({
  dots: false,
  infinite: true,
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1000,
  cssEase: 'linear'
});
    
    
    $('.menu li').css("pointer-events", "auto");




     $('.insta_slider').slick({
  slidesToShow: 6,
   focusOnSelect: true,
  responsive: [
  {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768,
      settings: {

        slidesToShow: 3
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});


  





});

$(".input-number-wrap .fas").on("click", function() {

        var $button = $(this);
        var oldValue = $button.parents('.input-number-wrap').find("input").val();

        if ($button.hasClass('fa-caret-right')) {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }

        $button.parents().find("input").val(newVal);

    });




  $('.search_open').click(function(){
     $(this).addClass('hidden');
    $(this).parents().removeClass('collapsed');
    $('.search_box').focus();
    $('.search_close').removeClass('hidden');
    });
  
  $('.search_close').click(function(){
     $(this).addClass('hidden');
    $(this).parents().addClass('collapsed');
    $('.search_open').removeClass('hidden');
    });


  $(function () {
        $("#chkPassport").click(function () {
            if ($(this).is(":checked")) {
              
                $(".label1").html('Select standard sizes');
                $(".measurements_wrap").show();
               $('#extra').attr('name', 'id[]');
              $('#bust').attr('name', 'properties[Bust]');
              $('#shoulder').attr('name', 'properties[Shoulder]');
              $('#waist').attr('name', 'properties[Waist]');
              $('#hwaist').attr('name', 'properties[High Waist]');
              $('#lwaist').attr('name', 'properties[Low Waist]');
              $('#hips').attr('name', 'properties[Hips]');
              $('#sleeve').attr('name', 'properties[Arm sleeve]');
              $('#height').attr('name', 'properties[Height]');
              
            } else {
               $(".label1").html('Customise Fit');
                $(".measurements_wrap").hide();
              $("#extra").removeAttr("name");
               $('#bust').removeAttr('name');
              $('#shoulder').removeAttr('name');
              $('#waist').removeAttr('name');
              $('#hwaist').removeAttr('name');
              $('#lwaist').removeAttr('name');
              $('#hips').removeAttr('name');
              $('#sleeve').removeAttr('name');
              $('#height').removeAttr('name');
                
            }
        });
    });

})(jQuery);

function HeaderH() {
  var HeaderHeight = $('#header').height();
  $('.space-top').css('padding-top', HeaderHeight + 'px');
}

$(window).load(function(){
  HeaderH();
});

$(window).resize(function(){
  HeaderH();
});



       
$(document).on("scroll", function(){
		HeaderH();
	});












